import { Injectable } from '@angular/core';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class YoutubeApiService {

  constructor(private http: HttpClient) { }

  getVideoStatistics(videoID: string): Observable<Statistics> {
    return this.http.get<Statistics>('https://www.googleapis.com/youtube/v3/videos?id=' + videoID + '&key=AIzaSyCHfs7WTIxVDU8vKfh60dMghbGvISCmbW4&part=statistics');
  }
}

export interface Statistics {
  items: Array<any>;
}
